import {useMutation} from 'react-query';
import actions from '../../api/user/update';

const useMutateUpdateOrganisation = () => {
  return useMutation(async (data: any) => {
    await actions.updateOrganisation(data);
  }, {retry: false});
};

export default useMutateUpdateOrganisation;
